<div class="step-page">
	<div class="step-title">
		<div class="title">Online User Guide</div>
		<div class="button">
			<div *ngIf="selectedStatus.name !== 'Intro'" class="button-general" [routerLink]="selectedStatus.toState">{{selectedStatus.btnName}}</div>
		</div>
	</div>
	<div class="step-content">
		<!-- <div class="row-wrap">
			<a href="https://youtu.be/Jk3ajAF603Y" target="_blank" class="video-link">AZGIV Video Instructions</a>
		</div> -->
		<div class="status-header">
			<div class="status-wrap" *ngFor="let item of status" title="click to see the detials">
				<div [ngClass]="{'select-status': item===selectedStatus}" (click)="getGuideContent(item)">{{item.name}}</div><hr *ngIf="item.isLast === false">
			</div>
		</div>
		<div class="guide-content">
			<!-- <div class="left-panel">
				<div *ngIf="selectedStatus" class="steps-wrap">
					<div *ngFor="let step of selectedStatus.steps" 
					[ngClass]="{'selected-name': step===selectedStep}"
					class="steps-content"  
					(click)="getStepContent(step)">{{step.stName}}</div>
				</div>
			</div> -->
			<div class="panel">
				<!-- <div class="img-wrap"*ngIf="selectedStep">
					<img src="{{selectedStep.imageUrl}}">
				</div> -->
				<div *ngIf="selectedStatus.name === 'Intro'" class="intro-panel">
					<!-- <div>Introduction is under development</div> -->
					<a href="https://youtu.be/Jk3ajAF603Y" target="_blank" class="video-link">AZGIV - An NG911 Readiness Platform</a>
					<a href="https://youtu.be/a_JROsWp6go" target="_blank" class="video-link">AZGIV Quality Assurance</a>
					<a href="https://youtu.be/2RBDui05B7g" target="_blank" class="video-link">ArcGIS Plugin for AZGIV</a>
					<a href="https://youtu.be/Vi8bH-ZuPr0" target="_blank" class="video-link">Integrator-Agency Workflow</a>
					<a href="https://youtu.be/Oklm_6FrGEA" target="_blank" class="video-link">Multi-Level Agency Workflow</a>  
					<a href="https://youtu.be/XevpRiFfqHw" target="_blank" class="video-link">Resetting Your Password and Inviting Users</a>
				</div>
				<div *ngFor="let step of selectedStatus.steps" class="img-wrap">
					<img src="{{step.imageUrl}}">
				</div>
				
			</div>
		</div>
	</div>
</div>
